<template>
    <popup-overlay>
        <popup-wrapper>
            <button
                class="modal-popup__close"
                :aria-lable="$t('POPUP_CLOSE')"
                @click.prevent="close" />

            <div class="text-base lg:text-2xl lg:tracking-loose mb-4 px-4">
                {{title}}
            </div>

            <div class="px-4 text-sm">
                <div v-html="description"></div>
            </div>

            <!-- Confirm switch -->
            <button
                class="cz2__modal-popup__button-ok cz2__modal-popup__group-button"
                @click.prevent="confirm">
                {{confirmMessage}}
            </button>

            <!-- Stay -->
            <button
                class="cz2__modal-popup__button-cancel cz2__modal-popup__group-button"
                @click.prevent="close">
                {{stayMessage}}
            </button>

            <!-- Save -->
            <!--
            <div class="cz2__leaving-save">
                <button
                    class="cz2__leaving-save__button"
                    @click.prevent="confirmSave">
                    <span class="cz2__leaving-save__button-icon" />
                    <span class="cz2__leaving-save__button-text text-sm">
                        {{$t('POPUP_LEAVING_SAVE')}}
                    </span>
                </button>
            </div>
            -->
        </popup-wrapper>
    </popup-overlay>
</template>

<style lang="scss">
    @import "../../style/variables.scss";
    #cz2.cz2 {
        .cz2__modal-popup__group-button {
            margin-top: 20px;
        }
    }
</style>

<script>
    import PopupOverlay from './PopupOverlay.vue';
    import PopupWrapper from './PopupWrapper.vue';

    export default {
        components: {
            PopupOverlay,
            PopupWrapper,
        },
        props: {
            switchTo: {
                type: String,
                default: 'group',
            },
        },
        computed: {
            title() {
                return this.switchTo === 'group'
                    ? this.$t('GROUP_ARE_YOU_SURE_GROUP')
                    : this.$t('GROUP_ARE_YOU_SURE_INDIVIDUAL');
            },
            description() {
                return this.switchTo === 'group'
                    ? this.$t('GROUP_SWITCH_TO_GROUP_DESCRIPTION')
                    : this.$t('GROUP_SWITCH_TO_INDIVIDUAL_DESCRIPTION');
            },
            confirmMessage() {
                return this.switchTo === 'group'
                    ? this.$t('GROUP_SWITCH_CONFIRM_GROUP')
                    : this.$t('GROUP_SWITCH_CONFIRM_INDIVIDUAL');
            },
            stayMessage() {
                return this.switchTo === 'group'
                    ? this.$t('GROUP_SWITCH_STAY_INDIVIDUAL')
                    : this.$t('GROUP_SWITCH_STAY_GROUP');
            },
            closeAction() {
                return this.switchTo === 'group'
                    ? 'showGroupConfirmation'
                    : 'showIndividualConfirmation';
            },
        },
        methods: {
            clearGroupTextPlacements() {
                const { filledTextPlacements } = this.$store.getters;
                for (let i = 0; i < filledTextPlacements.length; i += 1) {
                    const placement = filledTextPlacements[i];
                    if (placement.component.custom['personalization-text']) {
                        this.$store.dispatch('clearPlacement', placement);
                    }
                }

                this.$store.dispatch('setSecondaryBottles', []);
            },
            close() {
                this.$store.dispatch(this.closeAction, false);
            },

            confirm() {
                this.$store.dispatch(this.closeAction, false);
                if (this.switchTo === 'individual') {
                    this.clearGroupTextPlacements();
                }
                this.$store.dispatch('setIsGroupOrder', this.switchTo === 'group');
            },

            confirmSave() {
                this.$store.dispatch('saveWishlist');
            },
        },
    };
</script>
